<template>
  <div>
    <v-select
      class="custom-select2 font-size-xSmall"
      :options="options"
      @input="inputSelected"
      :placeholder="placeholder"
      v-model="local"
    >
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes"><i class="fa fa-caret-down text-color2"></i></span>
      </template>
    </v-select>
  </div>
</template>

<script>

import vSelect from 'vue-select'

export default {
  name: 'Select2',
  props: ['options', 'forgettable', 'placeholder'],
  components: {
    vSelect
  },
  data () {
    return {
      local: ''
    }
  },
  methods: {
    inputSelected (e) {
      this.$emit('input', e)
      this.$emit('change', e)
      if (this.forgettable) this.local = ''
    }
  }
}
</script>

<style lang="css" src="vue-select/dist/vue-select.css"></style>

<style lang="scss" scoped>

.custom-select2{
  ::v-deep {
    .vs__dropdown-toggle {
      background: #fff;
      border-radius: 30px;
      border: none;
      -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      padding: 10px 10px;
    }

    .vs__search, .vs__search:focus {
      margin: 0;
    }

    .vs__dropdown-menu {
      border: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
      -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
      margin-top: 6px;
    }

    .vs__dropdown-option {
      color: $color1;
      transition: all 0.2s ease-out;
      margin-bottom: 3px;
    }

    .vs__dropdown-option--highlight {
      background: transparent;
      color: $color2;
    }
  }
}

.default-style {
  ::v-deep {
    .custom-select2 {
      .vs__dropdown-toggle {
        border-radius: 8px;
        height: 54px;
        font-size: $font_size_small;
      }

      .vs__open-indicator {
        font-size: 16px;
      }

      .vs__actions {
        padding-top: 0;
      }
    }
  }
}

</style>
